import React from "react";
import "./template.css";

// Componentes
import TablaGastoXMetodo from "../vistaTotales/tablaGastoMetodo.js";
import TablaGastoXCategoria from "../vistaTotales/tablaGastoCategoria.js";


export default function TemplateTotales() {
    return (
        <div className="contenedor-template">
            <TablaGastoXMetodo/>
            <TablaGastoXCategoria/>
        </div>
    );
}

